<template>
  <div v-observe-visibility="{
         callback: visibilityChanged,
         throttle: 300,
         intersection: {
            threshold: 0.3
          }
         }"

       class="m-auto py-8 md:px-0 relative md:flex"
       style="max-width:1170px; scroll-snap-align: center"
  >

    <h2 class="font-bold text-2xl md:hidden p-4">{{ picture.title[locale()] }}</h2>
    <router-link tag="img" :to="'project/'+picture.slug"
                 class="picture-hero w-full md:w-2/3 cursor-pointer"
                 :class="{'appear':isVisible}"
                 :src="picture.cover_thumb"
                 :alt="picture.title[locale()]"
    />

    <div v-if="isVisible" class="px-2 text-left hidden md:block"
         :class="{'animate__animated animate__fadeIn':isVisible}"
    >
      <h2 class="font-bold text-2xl md:text-4xl unselectable">{{ picture.title[locale()] }}</h2>
      <div class="mb-6" v-html="shorten(picture.excerpt[locale()],240)"></div>

      <router-link class="project-link"  :to="'project/'+picture.slug">{{t('view_project')}}</router-link>

    </div>

  </div>
</template>
<script>
export default {
  name: 'project-hero',
  props: {
    picture: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      isVisible: false,
    }
  },
  computed: {},
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible
      if (isVisible) {
        this.$store.commit('setActiveProjectPath', this.picture.path);
      }
    },
  }
}
</script>

<style lang="scss" scoped>

.picture-hero {
  @apply px-2;
  //width: auto;
  //max-height: 50%;

  transform: scale(.95);
  opacity: 0;
  transition: all 0.5s ease;
}

.appear {
  opacity: 1;

  &:hover {
    opacity: 0.9;
  }

  transform: scale(1);
}


.project-link{
  @apply text-xs uppercase font-bold items-center inline-flex;
  &:before{
    content: '';
    border: 1px solid #86868b;
    width:10px;
    margin-right: 5px;
  }
  &:after{
    content: '';
    border: 1px solid #86868b;
    width:10px;
    margin-left: 5px;
  }
}
</style>
